import { render } from "./VendorManagementTable.vue?vue&type=template&id=6d7011b1&scoped=true"
import script from "./VendorManagementTable.vue?vue&type=script&lang=js"
export * from "./VendorManagementTable.vue?vue&type=script&lang=js"

import "./VendorManagementTable.vue?vue&type=style&index=0&id=6d7011b1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7011b1"]])

export default __exports__